import styled from "styled-components";
import { Atom } from 'AppReact';

const template = styled.div`
  height: 13px;
  width: 13px;
  margin-right: 2px;

  svg {
    height: 100%;
    width: 100%;
  }
`;

export default Atom({ type: 'label', dataType: 'object', template: template })